<template>
    <div>
        <v-alert
            border="right"
            colored-border
            color="secondary"
            type="info"
            elevation="1"
        >
        {{ title }}
        <div style="min-height:10px;"></div>
        <ul>
            <li>{{ text1 }}</li>
            <li>{{ text2 }}</li>
        </ul>
        <div style="min-height:15px;"></div>
        {{ text3 }}
        </v-alert>
    </div>
</template>

<script>

export default {
    name: 'info-user-type-domacin',
    data: () => ({
        title: 'Kartico tipa »Gost/pravna oseba« lahko pridobi:',
        text1: "samostojni podjetnik ali pravna oseba;",
        text2: "fizična oseba, ki nima stalnega prebivališča v Občini Bled oziroma njeno vozilo ni registrirano na naslovu v Občini Bled.",
        text3: "Kartica tipa »Gost/pravna oseba« omogoča uporabo parkirišč in javnih sanitarij v lasti Občine Bled ter prehod skozi območja, kjer je to določeno s prometno signalizacijo (npr. Koritno, Mlino, Lokalne ceste)."
    })
}

</script>